import { Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import React, { useEffect, useState } from "react";

import { getTranslateByKey, haveIgnoreElement, isNullUndefined } from "@/main/services/utils";
import TooltipComponent from "../tooltip/tooltipComponent";

import * as S from "./styles";

interface IKOGCollapseProps {
	header?: React.ReactNode;
	renderHeader?: (icon: React.ReactNode, toggle: (e?: React.MouseEvent) => void, expanded: boolean) => React.ReactNode;
	content: React.ReactNode;
	// Optional Props
	showIcon?: boolean;
	showBorder?: boolean;
	maxHeight?: string;
	overflow?: string;
	isOpenCollapseinitial: boolean;
	customIcon?: React.ReactNode;
	onCustomCollapse?: (expanded: boolean) => void;
	keepMounted?: boolean;
	titleTooltipIcon?: {
		showMore: string;
		showLess: string;
	};
	forceCollapseTrigger?: boolean;
	isFlexAccordion?: boolean;
	changeBorderOnExpand?: boolean;
}

function KOGCollapse({
	header,
	renderHeader,
	content,
	showIcon = true,
	showBorder = true,
	changeBorderOnExpand = true,
	maxHeight,
	overflow,
	customIcon,
	titleTooltipIcon,
	isOpenCollapseinitial,
	onCustomCollapse = () => {},
	keepMounted = false,
	forceCollapseTrigger,
	isFlexAccordion = false,
}: IKOGCollapseProps) {
	const [expanded, setExpanded] = useState(isOpenCollapseinitial);

	useEffect(() => {
		if (forceCollapseTrigger && expanded) {
			setExpanded(false);
			onCustomCollapse(false);
		}
	}, [forceCollapseTrigger]);

	//#region Handle Functions
	function handleClickHeader(e?: React.MouseEvent | React.MouseEvent<HTMLDivElement>) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
			if (e.target && haveIgnoreElement(e.target as HTMLElement)) return;
		}
		setExpanded((prev) => !prev);
		onCustomCollapse(!expanded);
	}
	//#endregion

	//#region Mini Components
	function IconExpand() {
		const renderTitleShowMore = isNullUndefined(titleTooltipIcon)
			? getTranslateByKey("information.showMore")
			: titleTooltipIcon.showMore;
		const renderTitleShowLess = isNullUndefined(titleTooltipIcon)
			? getTranslateByKey("information.showLess")
			: titleTooltipIcon.showLess;

		if (!isNullUndefined(customIcon)) return <S.CustomIcon>{customIcon}</S.CustomIcon>;

		return (
			<TooltipComponent placement="top" title={expanded ? renderTitleShowLess : renderTitleShowMore}>
				{expanded ? (
					<ExpandLess color="primary" aria-expanded={expanded} aria-label={getTranslateByKey("information.showMore")} />
				) : (
					<ExpandMore color="primary" aria-expanded={expanded} aria-label={getTranslateByKey("information.showMore")} />
				)}
			</TooltipComponent>
		);
	}
	//#endregion

	return (
		<S.ContainerCollapse
			$hasExpand={expanded}
			$showBorder={showBorder}
			$changeBorderOnExpand={changeBorderOnExpand}
			$maxHeight={maxHeight}
			$overflow={overflow}
			$isFlexAccordion={isFlexAccordion}
		>
			{renderHeader ? (
				renderHeader(showIcon ? IconExpand() : null, handleClickHeader, expanded)
			) : (
				<S.WrapperHeader $hasExpand={expanded} onClick={handleClickHeader}>
					{header}
					{showIcon && IconExpand()}
				</S.WrapperHeader>
			)}
			<Collapse in={expanded} timeout="auto" unmountOnExit={!keepMounted} style={{ overflow: "hidden" }}>
				<S.WrapperContent $isFlexAccordion={isFlexAccordion}>{content}</S.WrapperContent>
			</Collapse>
		</S.ContainerCollapse>
	);
}

export default KOGCollapse;
